import { XMarkIcon } from "@heroicons/react/24/solid";
import { toast, Toast } from "react-hot-toast";
import { t } from "i18next";

interface DismissibleToastProps {
  toastObj: Toast;
  message: string;
  title?: string;
}

export const DismissibleToast = ({ toastObj, message, title }: DismissibleToastProps) => {
  return (
    <div className="flex flex-col gap-2 w-full">
      <div className="flex items-start justify-between gap-4 w-full">
        <p style={{ color: "#065F46" }} className="m-0 leading-tight font-bold">
          {title || t("Successfully created !")}
        </p>
        <XMarkIcon 
          className="w-4 h-4 cursor-pointer flex-shrink-0" 
          style={{ color: "#065F46" }} 
          onClick={() => toast.dismiss(toastObj.id)} 
        />
      </div>
      <p style={{ color: "#065F46" }} className="m-0 leading-tight font-medium text-sm">
        {message}
      </p>
    </div>
  );
};

export const showOdooSuccessToast = (message: string, title?: string) => {
  toast.success(
    (toastInstance) => <DismissibleToast toastObj={toastInstance} message={message} title={title} />,
    {
      duration: 30000, // 30 seconds
    }
  );
};
